var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{attrs:{"outlined":_vm.isPdf ? false : true}},[_c('v-card-title',[_vm._v("Notes")]),_c('div',{staticClass:"px-4 pb-4"},[_c('AnalyticsDetailRow',{attrs:{"icon":"notepad.svg","title":`${this.currentEvent.analyticsData.eventNotes} notes created`,"value":"","show-view-button":true},on:{"onView":_vm.view}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }